export default __webpack_public_path__ + "static/media/cautionIcon.275f8367.svg";